import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getCodeRequest = (email) => {
  const url = apiURl + "verifications/sendEmail";

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(email.email),
  };
  return fetchAndReturn(url, parameters);
};

const changePasswordRequest = ({ payload }) => {
  const url = apiURl + "users/passwordRecovery";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  return fetchAndReturn(url, parameters);
};

const getMenuCategoriesRequest = (token, organizationId) => {
  const url =
    apiURl +
    "mymenu/configurations/MenuCategories/All?organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getAllUsers = async (token) => {
  const url = apiURl + "users/getall";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getAllAccessRequest = async (token) => {
  const url = apiURl + "access/getall";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const deleteUserRequest = async (token, user) => {
  const url = apiURl + "users/delete";
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(user),
  };

  return fetchAndReturn(url, parameters);
};

const updateUserRequest = async (user, token) => {
  const url = apiURl + "users/edit";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(user),
  };

  return fetchAndReturn(url, parameters);
};

export {
  getAllUsers,
  getAllAccessRequest,
  updateUserRequest,
  deleteUserRequest,
  getCodeRequest,
  changePasswordRequest,
  getMenuCategoriesRequest,
};
